import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const SubmitLogin = createAsyncThunk(
  "SubmitLogin",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/login",
        {
          Email: data1["Email"],
          otp: data1["otp"],
          // orders: [1, 2, 3],
          // photo: document.querySelector('#fileInput').files
        },
        {
          headers: myHeaders(),
        }
      );
      localStorage.setItem("access_token", data["access_token"]);
      localStorage.setItem("Email", data["Email"]);
      return data;
    } catch (error) {
      if (error?.response?.status > 399) {
        localStorage.clear();
        // window.location.assign("/");
        return rejectWithValue("invalid OTP");
      }
      console.error("!!!", error);
      if (error.code === "ERR_NETWORK") {
        return rejectWithValue("Server Is Under Maintenance");
      }
    }
  }
);

const LoginSlice = createSlice({
  name: "Login",
  initialState: {
    LoginResponce: ["hide", ""],
  },
  extraReducers: (builder) => {
    builder
      .addCase(SubmitLogin.fulfilled, (state, action) => {
        state.LoginResponce = ["", "Success"];
      })
      .addCase(SubmitLogin.pending, (state, action) => {
        state.LoginResponce = ["hide", ""];
      })
      .addCase(SubmitLogin.rejected, (state, action) => {
        state.LoginResponce = ["", action.payload];
      });
  },
});

export default LoginSlice.reducer;
